'use client'

import Pretitle from '@/components/Pretitle'

// Soleno logomark — same path used in Navbar/page hero stencil.
const ICON_PATH = 'M428.09 175.63C426.234 173.773 423.717 172.726 421.09 172.72H318.79L391.14 100.37C392.065 99.4469 392.799 98.3504 393.3 97.1432C393.8 95.9361 394.058 94.6421 394.058 93.3352C394.058 92.0284 393.8 90.7343 393.3 89.5272C392.799 88.32 392.065 87.2234 391.14 86.3002L344.69 39.8502C343.767 38.9253 342.67 38.1915 341.463 37.6908C340.256 37.1902 338.962 36.9325 337.655 36.9325C336.348 36.9325 335.054 37.1902 333.847 37.6908C332.64 38.1915 331.543 38.9253 330.62 39.8502L258.27 112.2V9.9302C258.269 8.62064 258.009 7.32422 257.505 6.11548C257.001 4.90673 256.263 3.80946 255.334 2.88672C254.405 1.96397 253.302 1.23395 252.09 0.738584C250.878 0.243219 249.58 -0.00772431 248.27 0.00018113H182.59C181.285 -0.00113275 179.992 0.25467 178.786 0.752989C177.579 1.25131 176.483 1.98239 175.559 2.90448C174.635 3.82656 173.901 4.9216 173.401 6.12707C172.9 7.33255 172.642 8.62486 172.64 9.9302V112.11L100.37 39.8502C99.4478 38.9256 98.3521 38.192 97.1458 37.6915C95.9394 37.1909 94.6462 36.9333 93.3402 36.9333C92.0341 36.9333 90.741 37.1909 89.5346 37.6915C88.3283 38.192 87.2326 38.9256 86.3102 39.8502L39.8602 86.2902C38.9329 87.2121 38.197 88.3082 37.6948 89.5156C37.1927 90.7229 36.9341 92.0176 36.9341 93.3252C36.9341 94.6328 37.1927 95.9275 37.6948 97.1348C38.197 98.3422 38.9329 99.4383 39.8602 100.36L112.21 172.71H9.95019C8.63895 172.709 7.34039 172.967 6.12933 173.47C4.91827 173.972 3.81863 174.71 2.89377 175.639C1.9689 176.569 1.23709 177.672 0.740477 178.886C0.243864 180.099 -0.00773452 181.399 0.000181133 182.71C-0.0024715 202.78 7.96701 222.029 22.1557 236.223C36.3444 250.418 55.5903 258.395 75.6602 258.4H145.66C157.607 258.4 169.427 260.846 180.393 265.588C191.359 270.329 201.237 277.266 209.42 285.97C210.192 286.808 211.129 287.476 212.172 287.934C213.215 288.391 214.341 288.627 215.48 288.627C216.619 288.627 217.746 288.391 218.789 287.934C219.832 287.476 220.769 286.808 221.54 285.97C229.719 277.266 239.594 270.329 250.556 265.587C261.519 260.846 273.336 258.4 285.28 258.4H355.33C375.4 258.395 394.646 250.418 408.835 236.223C423.023 222.029 430.993 202.78 430.99 182.71C431 181.397 430.748 180.095 430.25 178.879C429.752 177.664 429.018 176.56 428.09 175.63ZM245.84 209.18C238.826 216.185 229.601 220.541 219.735 221.507C209.869 222.473 199.974 219.988 191.735 214.477C183.496 208.965 177.422 200.767 174.549 191.28C171.676 181.793 172.182 171.603 175.979 162.446C179.776 153.29 186.631 145.733 195.375 141.063C204.119 136.394 214.212 134.9 223.933 136.837C233.655 138.774 242.404 144.022 248.691 151.686C254.977 159.351 258.412 168.957 258.41 178.87C258.41 184.501 257.299 190.076 255.142 195.276C252.985 200.477 249.824 205.202 245.84 209.18Z'

type LinkItem = { label: string; href: string }
type LinkColumn = { title: string; links: LinkItem[] }

// Six grouped link sections — Soleno-aligned content matching the
// reference layout (Industries / Services / Company on top row,
// Resources / Solutions / Technologies on bottom row).
const COLUMNS: LinkColumn[] = [
  {
    title: 'Industries',
    links: [
      { label: 'SaaS & Startups', href: '/#services' },
      { label: 'Healthcare & Education', href: '/industries/healthcare-education' },
      { label: 'Real Estate & Proptech', href: '/contact' },
      { label: 'AI Product Companies', href: '/services/ai-integration' },
      { label: 'Restaurants', href: '/contact' },
      { label: 'Agencies & Professional Services', href: '/contact' },
    ],
  },
  {
    title: 'Services',
    links: [
      { label: 'Custom Development', href: '/services/custom-development' },
      { label: 'Framer Development', href: '/services/framer-development' },
      { label: 'SEO Optimization', href: '/services/seo-optimization' },
      { label: 'AI Integration', href: '/services/ai-integration' },
      { label: 'MVP Development', href: '/contact' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/#about' },
      { label: 'Our Process', href: '/#services' },
      { label: 'Selected Work', href: '/#work' },
      { label: 'Blog', href: '/blog' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Blog', href: '/blog' },
      { label: 'Case Studies', href: '/#work' },
      { label: 'FAQ', href: '/#faq' },
      { label: 'Testimonials', href: '/#work' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'MVP for Startups', href: '/contact' },
      { label: 'Product Redesign', href: '/contact' },
      { label: 'SaaS Development', href: '/services/custom-development' },
      { label: 'AI Product Development', href: '/services/ai-integration' },
      { label: 'CMS Migration', href: '/services/custom-development' },
    ],
  },
  {
    title: 'Technologies',
    links: [
      { label: 'React / Next.js', href: '/services/custom-development' },
      { label: 'Technical SEO', href: '/services/seo-optimization' },
      { label: 'Framer', href: '/services/framer-development' },
      { label: 'AI / OpenAI', href: '/services/ai-integration' },
      { label: 'TailwindCSS', href: '/services/custom-development' },
    ],
  },
]

const SOCIALS = [
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/solenohq/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.37V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.38-1.85 3.61 0 4.28 2.38 4.28 5.47v6.27zM5.34 7.43a2.06 2.06 0 11.001-4.121A2.06 2.06 0 015.34 7.43zM7.12 20.45H3.56V9h3.56v11.45z" />
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/solenohq/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
]

function FooterColumn({ title, links }: LinkColumn) {
  return (
    <div>
      <Pretitle className="text-brand-400 mb-5">[ {title} ]</Pretitle>
      <ul className="space-y-3">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.href}
              className="after:hidden text-sm text-white/65 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default function Footer() {
  return (
    <footer
      data-nav-theme="dark"
      data-bg="#0f0f0f"
      className="bg-[#0f0f0f] text-white/65 relative"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 border-x border-white/[0.06]">
        {/* Main grid: tagline+logo+socials on the left, link columns on the right */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-12 lg:gap-20 py-16 md:py-20">
          {/* Left — tagline, logo, socials */}
          <div className="flex flex-col justify-between gap-12 min-h-[280px]">
            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-sm">
              Your idea deserves more than prototypes. Partner with Soleno to ship
              scalable, reliable, AI-enhanced products founders are proud of.
            </p>

            <div>
              <a href="/" className="after:hidden inline-flex items-center gap-3">
                <svg viewBox="0 0 431 289" className="w-8 h-8 text-white" xmlns="http://www.w3.org/2000/svg">
                  <path d={ICON_PATH} fill="currentColor" />
                </svg>
                <span className="font-display font-medium text-[22px] md:text-[28px] tracking-tight text-white">
                  Soleno
                </span>
              </a>

              <div className="flex items-center gap-3 mt-5">
                {SOCIALS.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    className="after:hidden w-9 h-9 rounded-md flex items-center justify-center text-white/70 hover:text-white border border-white/[0.08] hover:border-white/20 transition-colors duration-200"
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right — 6 link columns in a 3×2 grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-12">
            {COLUMNS.map((col) => (
              <FooterColumn key={col.title} {...col} />
            ))}
          </div>
        </div>

        {/* Bottom row — copyright + legal links */}
        <div className="border-t border-white/[0.06] py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/70">
            &copy; {new Date().getFullYear()}, Soleno. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="/privacy" className="after:hidden text-xs text-white/70 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="/terms" className="after:hidden text-xs text-white/70 hover:text-white transition-colors">
              Terms and Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
